module.exports = __webpack_public_path__ + "img/HA2507-38.c2465fd1.jpg";